/**
 * Value for the `data-mdlfy-cms` attribute that makes a database text value editable in the
 * preview. Returns undefined when the value did not come from a database row.
 */
export const cmsTag = (table: string, id: string | null | undefined, column: string): string | undefined => {
    return id ? `${table}:${id}:${column}` : undefined
}
